module.exports = __webpack_public_path__ + "fonts/61d09f0.ttf";